import LoginMethods from './LoginMethods';

export default LoginMethods;
